// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e04e494d","186":"3f9a9eba","272":"20ed800a","372":"a4b00bdc","377":"8e1da000","738":"0b8c9645","841":"10aac3af","851":"cfb4677f","856":"ddbcb16f"}[chunkId] + ".chunk.js";
};